import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { Http } from "../../utils/http";

export interface searchXiaohongshuUserArticleParams extends ActiomCommonParams {
    searchValue: string;
}

const parseXhsDom = (
    domString: string,
): { user: { userPageData: Record<string, unknown>; notes: Record<string, unknown> } } => {
    const match = domString.match(/window\.__INITIAL_STATE__\s*=\s*(\{[\s\S]*\})/);
    if (!match) {
        if (domString.indexOf("website-login/captcha") !== -1) {
            throw new Error("当前信息需要登录后方可查看！");
        }
        throw new Error("小红书页面数据检索失败！");
    }
    const jsObjectStr = match[1];
    return new Function(`return ${jsObjectStr}`)();
};

export type PublishAction = CommonAction<searchXiaohongshuUserArticleParams, Record<string, unknown>>;

export const searchXiaohongshuUserArticle: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
    };

    const args: AxiosProxyParams = [
        { headers },
        _task.logger,
        params.proxyLoc,
        params.localIP,
        // params.huiwenToken,
        params.accountId,
    ];
    const http = new Http(...args);

    // const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    // if (!a1Cookie) return {code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: []};
    if (params.searchValue.indexOf("user/profile") === -1)
        return { code: 414, message: "请输入正确的小红书用户主页链接地址！", data: {} };

    const result = await http.api<string>(
        {
            method: "get",
            url: params.searchValue,
            defaultErrorMsg: "用户搜索异常，请稍后重试。",
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    let INITIAL_STATE = {
        user: { userPageData: {}, notes: {} },
    };
    try {
        INITIAL_STATE = parseXhsDom(result);
    } catch (error) {
        return response(414, (error as Error).message, {});
    }

    const isSuccess = INITIAL_STATE !== null;
    const message = `用户文章信息获取${isSuccess ? "成功！" : "失败，请检查！"}${_task.debug ? ` ${http.proxyInfo}` : ""}`;

    return response(isSuccess ? 0 : 414, message, INITIAL_STATE);
};
